module.exports = __webpack_public_path__ + "img/stellini_loader.8f8ee23d.svg";